module.exports = __webpack_public_path__ + "69a0bfa69031ffd32a045bf53460936b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/middle-cylinder-part.png
// module id = 809
// module chunks = 0